import { type Html, html, View } from 'rune-ts';
import klass from './EventBanner.module.scss';
import { typo } from '../../../../../shared/typography/typo';
import { getResizedUrl } from '../../../../../shared/util/image';
import { ListMarkIcon } from '@services/MarppleShop/shared/components/atoms/Icon';
import {
  makeMinusIcon,
  makePlusIcon,
} from '@services/MarppleShop/shared/components/atoms/Icon/landing_icons.ts';
import { font } from '@services/MarppleShop/shared/typography';
import { isNull, pipe, throwIf } from '@fxts/core';

export class EventBanner extends View {
  constructor() {
    super({});
  }

  override template(): Html {
    const texts = {
      desc_item_header_1: '이벤트 대상',
      desc_item_header_2: '이벤트 기간',
      desc_item_header_3: '이벤트 혜택',
      desc_item_header_4: '혜택 적용기간',
      desc_item_body_1: '핸드메이드 크리에이터',
      desc_item_body_2: '2025년 1월 13일 ~ 3월 31일까지',
      desc_item_body_3: '크리에이터배송 상품의 판매 수수료 0%',
      desc_item_body_4: '마플샵 판매 승인 시점 ~ 2025년 12월 31일까지',
      sub_desc_1: '※ PG사 수수료 3.2%(VAT 별도)는 추가 부과됩니다.',
      sub_desc_2: '※ 3월 31일 이후 신청시, 수수료 0% 혜택이 적용되지 않습니다.',
      event_caution: '이벤트 주의사항',
    };

    return html`
      <section class="${klass.container}">
        <img
          class="${klass.coin_image}"
          src="${getResizedUrl({
            url: '//s3.marpple.co/files/u_4648126/2025/1/original/a75bb3602b3eac1577e97c1fde42ab03bd8af45e1.png',
            format: 'webp',
            quality: 85,
          })}"
          alt="핸드메이드 크리에이터 이벤트 코인 이미지"
        />

        <img
          class="${klass.coin_image_2}"
          src="${getResizedUrl({
            url: '//s3.marpple.co/files/u_4648126/2025/1/original/24d082ace1cdf280dfbc1111f31649c568090b332.png',
            format: 'webp',
            quality: 85,
          })}"
          alt="핸드메이드 크리에이터 이벤트 코인 이미지"
        />

        <div class="${klass.content_container}">
          <div class="${klass.desc_wrapper}">
            <div class="${klass.desc_list} ${typo('14_medium')}"">
            <div class="${klass.desc_item}">
              <span class="${klass.desc_item_header}">${texts.desc_item_header_1}</span>
              <span>${texts.desc_item_body_1}</span>
            </div>
              <div class="${klass.desc_item}">
                <span class="${klass.desc_item_header}">${texts.desc_item_header_3}</span>
                <span>${texts.desc_item_body_3}</span>
              </div>
              <div class="${klass.desc_item}">
                <span class="${klass.desc_item_header}">${texts.desc_item_header_4}</span>
                <span>${texts.desc_item_body_4}</span>
              </div>
            </div>
            <div class="${klass.sub_desc_list} ${typo('12_medium')}">
              <div>${texts.sub_desc_1}</div>
            </div>
          </div>
        <div class="${klass.caution}">
            <div class="${klass.caution_title_wrapper}">
              <div class="${typo('14_bold')}">${texts.event_caution}</div>
              <div class="${klass.toggle_status}">
                ${makePlusIcon({ klass: klass.closed })} ${makeMinusIcon({ klass: klass.opened })}
              </div>
            </div>
            <div class="${klass.caution_body}">
              <div class="${klass.caution_wrapper} ${font('14_medium', '12_medium')}">
                <div class="${klass.caution_item}">
                  ${ListMarkIcon} 본 프로모션의 혜택 적용 기간은 판매 승인 시점부터 2025년 12월
                  31일까지입니다.
                </div>
                <div class="${klass.caution_item}">
                  ${ListMarkIcon} 본 프로모션은 크리에이터가 직접 제작 및 배송하는 '크리에이터배송 상품' 판매
                  수익에만 적용됩니다.
                </div>
                <div class="${klass.caution_item}">
                  ${ListMarkIcon} 다음과 같은 경우, 프로모션 혜택이 적용되지 않습니다.
                </div>
                <div class="${klass.caution_item} ${klass.caution_item_sub}">
                  ${ListMarkIcon} 프로모션 기간 이후, 크리에이터 신청을 완료한 경우
                </div>
                <div class="${klass.caution_item} ${klass.caution_item_sub}">
                  ${ListMarkIcon} 프로모션 기간 이전, 이미 핸드메이드 크리에이터로 신청하여 마플샵 판매 승인이
                  완료된 경우
                </div>
                <div class="${klass.caution_item} ${klass.caution_item_sub}">
                  ${ListMarkIcon} 핸드메이드가 아닌 다른 카테고리의 크리에이터일 경우
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    `;
  }

  override onMount() {
    this.delegate('click', `.${klass.caution_title_wrapper}`, () => {
      const caution = pipe(this.element().querySelector<HTMLElement>(`.${klass.caution}`), throwIf(isNull));
      caution.classList.toggle(`${klass.is_open}`);
      const caution_body = pipe(
        this.element().querySelector<HTMLElement>(`.${klass.caution_body}`),
        throwIf(isNull),
      );
      const caution_wrapper = pipe(
        this.element().querySelector<HTMLElement>(`.${klass.caution_wrapper}`),
        throwIf(isNull),
      );
      caution_body.style.height = caution.matches(`.${klass.is_open}`)
        ? `${caution_wrapper.clientHeight}px`
        : '0px';
    });
  }
}
